import { FaTimesCircle } from 'react-icons/fa'

const Component = (props) => <div className='border-3 border-success p-8 rounded-md mb-8'>
  {props.closeFn && <div className='float-right text-md ml-4 mb-4 cursor-pointer' onClick={props.closeFn}><FaTimesCircle style={{ fontSize: '20px' }} /></div>}
  {props.children}
</div>

export default Component
